import { synUtil } from "../../../../javascript/Utilities";
import { AjaxSolr } from "../../core/Core.js";
import { escapeForSolr, unescapeForSolr } from "../../core/synerisSolrBase.js";
import "../../core/AbstractTextWidget.js";

(function ($) {
    AjaxSolr.SynerisSearchBoxWidget = AjaxSolr.AbstractTextWidget.extend({
        _doRequestInternal: function (self, $target) {
            let input = $target.find("input.queryField");
            let value = input.val();
            let escaped = escapeForSolr(value);
            if (value) {
                self.set(escaped);
                synUtil.toggleEnabledState(input, false);
                input.val("");
                self.manager.doRequest();
            }
        },
        constructor: function (attributes) {
            AjaxSolr.extend(this, { autoCompleteFacets: [], facets: [] }, attributes);

            let self = this;
            let $target = $(self.target).addClass("searchBoxWidget");
            if ("phone" === synUtil.clientDeviceClass)
                $(self.target).addClass("phone");

            if (!$target.children(".queryField").length) {
                $('<div class="input-group"><input type="text" class="k-textbox form-control queryField ui-autocomplete-input" autocomplete="off" maxlength="500"><span class="input-group-addon"><i class="fa fa-search"></i></span></div>').appendTo($target);
                let synonyms = synUtil.Strings.getValue("searchsynonyms", "Synonyms");
                let btn = $('<button type="button" class="btn btn-primary synonymButton"><i class="fa fa-check"></i>' + synonyms + '</button>')
                    .click(function () {
                        if ($(this).hasClass("inactive"))
                            $(this).removeClass("inactive").addClass("btn-primary");
                        else
                            $(this).addClass("inactive").removeClass("btn-primary");
                    })
                    .appendTo($target)
                $('<div class="synonymDiv"></div>').appendTo($target);

                $target.find(".queryField").click(function (event) {
                    event.stopPropagation();
                });

                $(self.target).find('input.queryField').bind('keydown', function (e) {
                    if (e.which === 13) {
                        let input = $(this);
                        let value = input.val();
                        let menu = $(this).data("uiAutocomplete").menu.element;
                        let focused = menu.find("li:has(a.ui-state-focus)");
                        if (!focused.length) {
                            self._doRequestInternal(self, $target);
                        }
                    } else if (e.which === 9)
                        e.preventDefault();
                });
                $(self.target).find('span.input-group-addon').bind('click', function (e) {
                    self._doRequestInternal(self, $target);
                });
                self.createAutoComplete(self.autoCompleteFacets);
            }
        },
        beforeRequest: function () {
            let synonymButton = $(this.target).find("button.synonymButton");
            $(this.target).data("pendingrequest", true);
            $(this.target).find('input.queryField').autocomplete("close");
            let q = this.get();
            if (q && q !== "*:*" && !synonymButton.hasClass("inactive")) {
                this.manager.store.get("debugQuery").val("on");
                this.manager.store.get("defType").val("syneris_qparser");
                this.manager.store.get("synonyms").val("true");
            } else {
                this.manager.store.remove("debugQuery");
                this.manager.store.add("defType");
                this.manager.store.add("synonyms");
            }
            if (q && q !== "*:*") {
                this.manager.store.get("spellcheck").val("true");
                this.manager.store.get("spellcheck.q").val(this.get());
            }
        },
        reasonForNotExpanding: {
            "PluginDisabled": "You have to set synonyms=true to enable the plugin",
            "NoAnalyzerSpecified": "You defined >1 synonym analyzer in your configuration, but you left synonyms.analyzer empty",
            "AnalyzerNotFound": "There's no analyzer with the name you specified in synonyms.analyzer",
            "IgnoringPhrases": "synonyms.disablePhraseQueries is set to true, and this query contains a phrase (\"like this\")",
            "UnhandledException": "Whoops, we ran into an exception we couldn't handle!  File a bug",
            "HasComplexQueryOperators": "synonyms.ignoreQueryOperators is set to true, and this query contains complex query "
                + "operators (e.g. AND, OR, *, -, etc.)",
            "DidntFindAnySynonyms": "No synonyms found for this query.  Check your synonyms file"
        },
        afterRequest: function () {
            let input = $(this.target).find("input.queryField");
            let resp = this.manager.response;
            let synonymDiv = $(this.target).find(".synonymDiv").html("");

            if (resp.debug) {
                if (resp.debug.reasonForNotExpandingSynonyms) {
                    let reasonName = resp.debug.reasonForNotExpandingSynonyms.name;
                    let text = this.reasonForNotExpanding[reasonName];
                    if (text && reasonName !== "PluginDisabled" && reasonName !== "DidntFindAnySynonyms")
                        synonymDiv.addClass("synonymWarning").html('<i class="fa fa-warning"></i>' + kendo.htmlEncode(text));
                } else if (resp.debug.expandedSynonyms && resp.debug.expandedSynonyms.length)
                    synonymDiv.removeClass("synonymWarning").html('<i class="fa fa-arrow-right"></i>' + kendo.htmlEncode(resp.debug.expandedSynonyms.join(", ")));
            }

            if (this.manager.store.get("rows") !== "0") {
                let q = this.get();
                if (q && q !== "*:*")
                    input.val(unescapeForSolr(q));
                else
                    input.val("");
            }
            synUtil.toggleEnabledState(input, true);
        },
        cleanUp: function () {
            $(this.target).removeData("pendingrequest");
        },
        // Returns the index of searchText for which candidate starts with the 
        // substring(idx) of searchText. If no such index is found, -1 is returned.
        maxTrailingMatchIdx: function (searchText, candidate) {
            let c = candidate.toLowerCase(),
                s = searchText.toLowerCase();
            while (s) {
                if (!c.indexOf(s))
                    return searchText.length - s.length;
                s = s.replace(/^[\s]*[^\s]+[\s]?/, "");
                if (/^[\s]+$/.test(s))
                    s = "";
            }
            return -1;
        },
        createAutoComplete: function (autoCompleteFacets) {
            let self = this;
            let autoCompleteTitles = {};
            self.acFacets = []; // Autocomplete by fq
            self.acFields = []; // Autocomplete by dict

            $.each(autoCompleteFacets, function (idx, field) {
                if (field.indexOf("spellcheck_") === 0)
                    self.acFields.push(field);
                else
                    autoCompleteTitles[field] = self.facets[field].title;
                self.acFacets.push(field);
            });

            let input = $(this.target).find('input.queryField');

            input
                .autocomplete({
                    minLength: 3,
                    search: function (event, ui) {
                        if ($(self.target).data("pendingrequest"))
                            event.stopPropagation();
                    },
                    open: function (event, ui) {
                        if ($(self.target).data("pendingrequest"))
                            input.autocomplete("close");
                    },
                    source: function (request, response) {
                        let url = "WSProxy.axd?solr=" + self.core + "&facet=true&q=*:*&rows=0&facet.limit=1000&json.nl=map&wt=json";
                        let searchTerm = "";

                        let lastToken = function (syntaxTree) {
                            if (syntaxTree.field === "<implicit>")
                                return syntaxTree.term;
                            else if (syntaxTree.right)
                                return lastToken(syntaxTree.right);
                            else if (syntaxTree.left)
                                return lastToken(syntaxTree.left);
                            return undefined;
                        };

                        let parser = require("../../../../../3rd_party_libraries/lucene-parser/lucene_parser");

                        try {
                            let result = parser.lucene.LuceneParser.parse(request.term);
                            let lastTerm = lastToken(result);
                            let startIdx = request.term.lastIndexOf(lastTerm);
                            let endIdx = startIdx + lastTerm.length;


                            if (self.acFields.length) {
                                url += "&spellcheck=true&spellcheck.q=" + lastTerm.toLowerCase();
                            }
                            for (let i = 0; i < self.acFields.length; i++)
                                url += "&spellcheck.dictionary=" + self.acFields[i];

                            for (let i = 0; i < self.acFacets.length; i++)
                                url += "&facet.field=" + self.acFacets[i];

                            let autoCompleteReceived = function (data) {
                                let resp = [];
                                let minLength = input.data("uiAutocomplete").options.minLength;
                                let suggestObj = {};
                                if (self.acFields.length && data.spellcheck) {
                                    if (data.spellcheck.suggestions) {
                                        for (let key in data.spellcheck.suggestions) {
                                            if (key.length >= minLength && data.spellcheck.suggestions.hasOwnProperty(key)) {
                                                $.each(data.spellcheck.suggestions[key].suggestion, function (idx, suggestion) {
                                                    if (!suggestObj[suggestion] || suggestObj[suggestion].startIdx < data.spellcheck.suggestions[key].startOffset) {
                                                        suggestObj[suggestion] = {
                                                            label: suggestion,
                                                            value: suggestion,
                                                            type: "suggestion",
                                                            startIdx: startIdx,
                                                            endIdx: endIdx
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    }

                                    for (let key in suggestObj)
                                        resp.push(suggestObj[key]);

                                    resp.sort(function (a, b) {
                                        if (a.label < b.label)
                                            return -1;
                                        else if (b.label < a.label)
                                            return 1;
                                        return 0;
                                    });
                                }

                                let searchText = lastTerm.toLowerCase();
                                let earlierSearch = self.manager.store.get('q').val();
                                if (earlierSearch && earlierSearch !== "*:*") {
                                    if (searchText.length > earlierSearch.length && searchText.substring(0, earlierSearch.length) === earlierSearch)
                                        searchText = searchText.substring(earlierSearch.length).replace(/^\s/, "");
                                }

                                let matches = function (searchText, candidate) {
                                    let idx = self.maxTrailingMatchIdx(searchText, candidate);
                                    return idx >= 0 && searchText.substring(idx).length >= minLength;
                                };

                                let resultFacets = data.facet_counts.facet_fields;
                                for (let fieldname in resultFacets) {
                                    if (resultFacets.hasOwnProperty(fieldname)) {
                                        let facets = resultFacets[fieldname];
                                        let facetTitle = autoCompleteTitles[fieldname];
                                        let idx = 0;
                                        for (let fieldVal in facets) {
                                            if (facets.hasOwnProperty(fieldVal)) {
                                                // Either the search term matches the title of the facet field, then return all facets for that field
                                                // Else return only the facets with the text mathing the search term
                                                if (matches(searchText, facetTitle) || matches(searchText, fieldVal)) {
                                                    if (idx >= maxPerFacet)
                                                        break;
                                                    idx++;
                                                    resp.push({ label: fieldVal, value: fieldVal, type: "facet", facet: fieldname });
                                                }
                                            }
                                        }
                                    }
                                }
                                resp.sort(function (a, b) {
                                    let getCriteria = function (item) {
                                        if ("suggestion" === item.type)
                                            return "0" + (item.collation ? "1" : "0");
                                        else if ("facet" === item.type)
                                            return "1" + item.facet + "_" + item.label;
                                        return "2";
                                    };
                                    let critA = getCriteria(a);
                                    let critB = getCriteria(b);
                                    return (critA < critB ? -1 : (critA === critB ? 0 : 1));
                                });
                                response(resp);
                            };

                            let maxPerFacet = 20;
                            synUtil.getAJAXData({
                                url: url,
                                headers: { "__RequestVerificationToken": synUtil.requestVerificationToken },
                                done: autoCompleteReceived,
                                cache: false,
                                fail: function (jqXHR, textStatus, errorThrown, url) {
                                    let error = {
                                        ErrorDisplayMessage: synUtil.Strings.getValue("searcherror"),
                                        //ErrorStackTrace: printStackTrace().join('\n   '),
                                        InnerError: {
                                            ErrorDisplayMessage: jqXHR.responseJSON.error.msg,
                                            ErrorCode: jqXHR.responseJSON.error.code
                                        }
                                    };
                                    $.errorDialog("show", error);

                                }
                            });
                        }
                        catch (err) {
                            // eslint-disable-next-line no-console
                            console.log(err);
                        }
                    },
                    focus: function (event, ui) {
                        // prevent value inserted on focus
                        return false;
                    },
                    select: function (event, ui) {
                        let $target = $(self.target);

                        let enterPressed = false;
                        let orig = event.originalEvent;
                        if (orig)
                            if (orig.originalEvent && orig.originalEvent.type === "keydown" && orig.originalEvent.which === 13)
                                enterPressed = true;

                        if ("facet" === ui.item.type) {
                            self.manager.store.removeByValue('fq', new RegExp('^-?' + ui.item.facet + ':'));
                            self.manager.store.addByValue('fq', ui.item.facet + ':' + AjaxSolr.Parameter.escapeValue(ui.item.value));

                            val = input.val();
                            let idx = self.maxTrailingMatchIdx(val, ui.item.value);
                            if (idx >= 0) {
                                val = val.substring(0, idx).replace(/[\s]+$/g, "");
                                if (!val)
                                    val = "*:*";
                                self.manager.store.get("q").val(val);
                            }

                            let search = self.manager.store.get("q").val();
                            if (self.manager.requireSearchText && (!search || search === "*:*")) {
                                // If no fulltext query exists yet, we just add to the current search.
                                // Except when we do not need a query text, then we search freely
                                let cursearch = self.manager.getWidget(self.core + "_currentSearch");
                                cursearch.beforeRequest();
                                cursearch.afterRequest();
                                cursearch.cleanUp();
                            } else
                                self.manager.doRequest();

                            input.val("");
                        } else if ("suggestion" === ui.item.type) {
                            let val;
                            if (ui.item.collation)
                                val = ui.item.value;
                            else {
                                val = input.val().substring(0, ui.item.startIdx) + ui.item.value;
                                if (input.val().length > ui.item.startIdx + (ui.item.endIdx - ui.item.startIdx))
                                    val += input.val().substring(ui.item.endIdx);
                            }
                            input.val(val + (enterPressed ? "" : " "));
                            let search = self.manager.store.get('q').val(val);
                            if (enterPressed)
                                self.manager.doRequest();
                            input.focus();
                        }
                        return false;
                    }
                });
            let atc = input.data("uiAutocomplete");

            atc._renderItemData = function (ul, item) {

                let li = $("<li class='ui-autocomplete-item'></li>").data("ui-autocomplete-item", item);
                let a = $("<a></a>").appendTo(li);
                a.html(kendo.htmlEncode(item.label));
                if ("suggestion" === item.type) {
                    if (item.collation)
                        li.addClass("strong");
                    else {
                        let len = item.endIdx - item.startIdx;
                        a.html(kendo.htmlEncode(item.label.substring(0, len)));
                        a.append($("<span class='suggestSuffix'>" + kendo.htmlEncode(item.label.substring(len)) + "</span>"));
                    }
                }

                ul.append(li);
            };
            atc._renderMenu = function (ul, items) {
                let that = this,
                    currentFacet = "",
                    topicsAdded = false;
                $.each(items, function (index, item) {
                    if (item.facet && item.facet !== currentFacet) {
                        // Get Facet title for facet internal name
                        let facetTitle = autoCompleteTitles[item.facet] || item.facet;
                        ul.append("<li><div class='ui-autocomplete-facet'>" + facetTitle || item.facet + "</div></li>");
                        currentFacet = item.facet;
                    }
                    if (!topicsAdded && "topic" === item.type) {
                        ul.append("<li><div class='ui-autocomplete-facet'>Themen</div></li>");
                        topicsAdded = true;
                    }
                    that._renderItemData(ul, item);
                });
            };
        }
    });
})(jQuery);
